module.exports = __webpack_public_path__ + "static/goals_it_interview_art@2x-38fbb1624f548108c464b0b51455e940.png";